import { Controller } from "stimulus";
import moment from "moment";

export default class extends Controller {
  static targets = ["yearInput", "monthInput", "dayInput"]

  connect() {
    const dateFormat = "ll";

    $(this.datePickerInputTarget).datetimepicker({
      format: dateFormat,
      locale: moment.locale(),
      // debug: true
    });

    if (this.yearInputTarget.value && this.monthInputTarget.value && this.dayInputTarget.value) {
      const currentDate = moment(`${this.yearInputTarget.value}-${this.monthInputTarget.value}-${this.dayInputTarget.value}`, "YYYY-MM-DD");
      this.datePickerInputTarget.value = currentDate.format(dateFormat);
    }

    $(this.datePickerInputTarget).on("change.datetimepicker", (e) => {
      if (e.date) {
        this.yearInputTarget.value = e.date.format("YYYY");
        this.monthInputTarget.value = e.date.format("M");
        this.dayInputTarget.value = e.date.format("D");
      }
    });
  }

  get datePickerInputTarget() {
    return this.element.querySelector("input[type=text]");
  }
}
